import React from 'react';
import { RoomSectionHeaderProps } from './types';
import { RoomSectionHeadersMode } from '../../../../enums/RoomLayout';
import RoomHeadersList from './RoomHeadersList';
import RoomHeadersTabs from './RoomHeadersTabs';

interface Props extends RoomSectionHeaderProps {
  mode: RoomSectionHeadersMode;
}

const RoomHeaders: React.FC<Props> = (props: Props): JSX.Element => {
  const { mode, ...roomSectionHeaderProps } = props;

  if (mode === RoomSectionHeadersMode.Tabs) {
    return <RoomHeadersTabs {...roomSectionHeaderProps} />;
  }

  return <RoomHeadersList {...roomSectionHeaderProps} />;
};

export default RoomHeaders;
